import React from 'react';
import { Mail, Phone, MapPin, Facebook, Instagram } from 'lucide-react';
import { companyInfo } from '../mock';

const Footer = () => {
  return (
    <section className="py-32 px-8 md:px-16 bg-neutral-50">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-20">
          {/* Left - Contact Info */}
          <div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-light text-gray-900 mb-12">
              Kontakt
            </h2>
            
            <div className="space-y-8">
              {/* Owner */}
              <div>
                <p className="text-gray-500 text-sm mb-2 uppercase tracking-wide">Ejer</p>
                <p className="text-gray-900 text-xl md:text-2xl font-light mb-8">{companyInfo.contact.owner}</p>
              </div>

              {/* Phone */}
              <div>
                <p className="text-gray-500 text-sm mb-2 uppercase tracking-wide">Telefon</p>
                <a
                  href={`tel:${companyInfo.contact.phone.replace(/\s/g, '')}`}
                  className="flex items-center space-x-3 text-gray-900 text-xl md:text-2xl font-light hover:text-gray-600 transition-colors duration-300"
                >
                  <Phone className="w-5 h-5 text-gray-400" />
                  <span>{companyInfo.contact.phone}</span>
                </a>
              </div>

              {/* Email */}
              <div>
                <p className="text-gray-500 text-sm mb-2 uppercase tracking-wide">Email</p>
                <a
                  href={`mailto:${companyInfo.contact.email}`}
                  className="flex items-center space-x-3 text-gray-900 text-xl md:text-2xl font-light hover:text-gray-600 transition-colors duration-300"
                >
                  <Mail className="w-5 h-5 text-gray-400" />
                  <span>{companyInfo.contact.email}</span>
                </a>
              </div>

              {/* Address */}
              <div>
                <p className="text-gray-500 text-sm mb-2 uppercase tracking-wide">Adresse</p>
                <div className="flex items-start space-x-3">
                  <MapPin className="w-5 h-5 text-gray-400 mt-1" />
                  <div className="text-gray-900 text-xl md:text-2xl font-light">
                    <p>{companyInfo.contact.address}</p>
                    <p>{companyInfo.contact.city}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Social Media */}
            <div className="mt-12">
              <p className="text-gray-500 text-sm mb-4 uppercase tracking-wide">Find os på</p>
              <div className="flex space-x-4">
                <a
                  href={companyInfo.social.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-3 bg-gray-100 rounded-full hover:bg-gray-200 transition-colors duration-300"
                  aria-label="Facebook"
                >
                  <Facebook className="w-5 h-5 text-gray-700" />
                </a>
                <a
                  href={companyInfo.social.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-3 bg-gray-100 rounded-full hover:bg-gray-200 transition-colors duration-300"
                  aria-label="Instagram"
                >
                  <Instagram className="w-5 h-5 text-gray-700" />
                </a>
              </div>
            </div>
          </div>

          {/* Right - Empty space for balance */}
          <div></div>
        </div>

        {/* Logo */}
        <div className="mt-20 flex justify-center">
          <img 
            src="https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/g34rxuid_Udklip.PNG" 
            alt="Fryd! logo" 
            className="w-32 h-32 opacity-10 grayscale"
          />
        </div>

        {/* Footer Note */}
        <div className="mt-8 pt-8 border-t border-gray-200">
          <p className="text-gray-400 text-sm text-center">
            © {new Date().getFullYear()} {companyInfo.name} · Alle rettigheder forbeholdes
          </p>
        </div>
      </div>
    </section>
  );
};

export default Footer;
